import logo from './logo.svg';
import "bootstrap/dist/css/bootstrap.min.css";
import './App.css';
import Login from "./Pages/Login/Login";
import Dashboard from "./Pages/Dashboard/Dashborad"
import { BrowserRouter as Router, Navigate, Route, Routes,useLocation } from "react-router-dom";
import React, { Suspense,useEffect } from "react";
import ProtectedRoute from "./utils/ProtectedRoute";
import Layout from './Components/Layout/Layout';
import Stripe from './Pages/Stripe/Stripe';
import StripeSuccess from './Pages/Stripe/StripeSuccess';
import InvoicePayment from './Pages/InvoicePayment/InvoicePayment';
import SucessPayment from './Pages/InvoicePayment/SucessPayment';
import ErrorPayment from './Pages/InvoicePayment/ErrorPayment';
import PaymentFinal from './Pages/InvoicePayment/PaymentFinal';
import Whatsnew from './Pages/Webview/Whatsnew';
import Terms from './Pages/Webview/Terms';
import Privacy from './Pages/Webview/Privacy';
import ReactGA from 'react-ga';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { HelmetProvider } from 'react-helmet-async';
const Customers = React.lazy(() => import('./Pages/Customers/Customers'));
const CustomerDetails = React.lazy(() => import('./Pages/Customers/CustomerDetails'));
const Invoices = React.lazy(() => import('./Pages/Invoices/Invoice'));
const CreateInvoice = React.lazy(() => import('./Pages/Invoices/CreateEditInvoice'));
const EditInvoice = React.lazy( () => import('./Pages/Invoices/EditInvoice'));
const InvoiceDetails = React.lazy(() => import('./Pages/Webview/InvoiceDetails'));
const EstimateDetails = React.lazy(() => import('./Pages/Webview/EstimateDetails'));
const InvoicePreview = React.lazy(() => import('./Pages/Webview/InvoicePreview'));
const EstimatePreview = React.lazy(() => import('./Pages/Webview/EstimatePreview'));
const Settings = React.lazy(() => import('./Pages/Settings/Settings'));
const Notifications = React.lazy(() => import('./Pages/Notifications/NotificationsList'));
const OtpLogs = React.lazy(() => import('./Pages/OtpLogs/Otp'));
const Estimate = React.lazy(() => import('./Pages/Estimates/Estimate'));
const CreateEstimate = React.lazy(() => import('./Pages/Estimates/CreateEstimate'));
const EstimateConfirm = React.lazy(() => import('./Pages/Estimates/EstimateConfirm'));
const  EstimateStatus = React.lazy(() => import('./Pages/Estimates/EstimateStatus'));
const EditEstimate = React.lazy(() => import('./Pages/Estimates/EditEstimate'));
const StripeConnect =  React.lazy(() => import('./Pages/Stripe/StripeConnect'));
function App() {
  const location = useLocation();
  const env = process.env.REACT_APP_ENV;
    
    
  useEffect(() => {
    if(env=='production'){
      ReactGA.initialize('G-K433BW5CFV');
      ReactGA.pageview(location.pathname + location.search);
    }
  }, [location]);
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <HelmetProvider>
    <ProtectedRoute>
    <Layout>
    <Routes>
      <Route path="/invoice/makepayment/:key" element={<InvoicePayment />}/>
      <Route path="/payment/success/:key" element={<SucessPayment />}/>
      <Route path="/payment/confirmation" element={<PaymentFinal />}/>
      <Route path="/payment/error/:key" element={<ErrorPayment />}/>
      <Route path="/" element={<Navigate to="/login" />} />
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/striperesponse*" element={<Stripe/>}/>
      <Route path="/stripe/success" element={<StripeSuccess/>}/>
      <Route path="/stripeconnect" element={<Suspense fallback={<div>Loading...</div>}><StripeConnect/></Suspense>}/>
      <Route path="/customers" element={<Suspense fallback={<div>Loading...</div>}><Customers/></Suspense>}/>
      <Route path="/customers/:key" element={<Suspense fallback={<div>Loading...</div>}><CustomerDetails/></Suspense>}/>
      <Route path="/invoices" element={<Suspense fallback={<div>Loading...</div>}><Invoices/></Suspense>}/>
      <Route path="/invoices/:type" element={<Suspense fallback={<div>Loading...</div>}><Invoices/></Suspense>}/>
      <Route path="/invoice/:key/details" element={<Suspense fallback={<div></div>}><InvoiceDetails/></Suspense>}/>
      <Route path="/invoice/:key/preview" element={<Suspense fallback={<div></div>}><InvoicePreview/></Suspense>}/>
      <Route path="/invoices/create" element={<Suspense fallback={<div>Loading...</div>}><CreateInvoice/></Suspense>}/>
      <Route path="/invoices/edit/:key" element={<Suspense fallback={<div>Loading...</div>}><EditInvoice/></Suspense>}/>
      <Route path="/settings" element={<Suspense fallback={<div>Loading...</div>}><Settings/></Suspense>}/>
      <Route path="/notifications" element={<Suspense fallback={<div>Loading...</div>}><Notifications/></Suspense>}/>
      <Route path="/otplogs" element={<Suspense fallback={<div>Loading...</div>}><OtpLogs/></Suspense>}/>
      <Route path="/*" element={<Navigate to="/dashboard" />}/>
      <Route path="/estimates" element={<Suspense fallback={<div>Loading...</div>}><Estimate/></Suspense>}/>
      <Route path="/estimates/:type" element={<Suspense fallback={<div>Loading...</div>}><Estimate/></Suspense>}/>
      <Route path="/estimate/:key/preview" element={<Suspense fallback={<div></div>}><EstimatePreview/></Suspense>}/>
      <Route path="/estimate/:key/details" element={<Suspense fallback={<div></div>}><EstimateDetails/></Suspense>}/>
      <Route path="/estimates/create" element={<Suspense fallback={<div>Loading...</div>}><CreateEstimate/></Suspense>}/>
      <Route path="/estimate/confirm/:key" element={<Suspense fallback={<div>Loading...</div>}><EstimateConfirm/></Suspense>}/>
      <Route path="/estimate/status/:type/:key" element={<Suspense fallback={<div>Loading...</div>}><EstimateStatus/></Suspense>}/>
      <Route path="/estimates/:type/:key" element={<Suspense fallback={<div>Loading...</div>}><EditEstimate/></Suspense>}/> 
      <Route path="/whatsnew" element={<Suspense fallback={<div>Loading...</div>}><Whatsnew/></Suspense>}/>
      <Route path="/privacypolicy" element={<Suspense fallback={<div>Loading...</div>}><Privacy/></Suspense>}/>  
      <Route path="/terms" element={<Suspense fallback={<div>Loading...</div>}><Terms/></Suspense>}/> 
    </Routes>
    </Layout>
    </ProtectedRoute>
    </HelmetProvider>
  </LocalizationProvider>
  );
}

export default App;
